import React, {useState, useRef} from 'react';

import "./MHeader.css";
import { Link, useNavigate } from 'react-router-dom';

import MapItButton from '../../Common/MapItButton/MapItButton';
import account_icon from '../../../Assets/UserPictureIcon-48x48.png';

import menu from '../../../Assets/menu64.png'
import cross from '../../../Assets/cross-mark.png'

const MHeader = ({create, setCreate, user, setUser, setRegMode, setEmail}) => {

    const [showAccList, setShowAccList] = useState(false);
    const menuRef = useRef();
    const iconRef = useRef();
    const [showMenu, setShowMenu] = useState(false);
    const [clicked, setClicked] = useState(false);
    let navigate = useNavigate();

    const sub_map = {
        0: "Single Plan",
        1: "Professional",
        2: "Professional"
    }

  const menuClick = () => {
    setShowMenu(!showMenu);
  }

  const onLogin = () => {
    setCreate(false);
    setRegMode(false);
    setShowMenu(!showMenu);
  }

  const onSignUp = () => {
    setCreate(false);
    setRegMode(true);
    setShowMenu(!showMenu);
  }

  const onLogout = () => {
    // localStorage.setItem("user", "");
    setCreate(false);
    setShowAccList(false);
    setShowMenu(false);
    setUser({});
    setEmail("");
    navigate("/login");
  }


  return(
    <div className="mBanner">
        <div className='mmenu-div'>
            <div className="mMapIt-logo-div">
            <Link to="/" spy={true} smooth={true}>
                <img src="https://d13dvi4jdbb8bg.cloudfront.net/MapIt-Logo-768x292px.png" 
                width="157.81vh" 
                height="60vh"
                alt="MapIt logo"/>
            </Link>            
            </div>
            {user && Object.keys(user).length !== 0 &&
            <div ref={iconRef} className='maccount-div'>
                <div>
                  <img 
                    src={account_icon} 
                    width="36"
                    height="36"
                    onClick={() => setShowAccList(!showAccList)} 
                    alt="account icon"
                  />
                </div>
            </div>
            }
            <div className="mmenu-icon">
                <img 
                src={showMenu?cross:menu} 
                width="24" 
                height="24" 
                onClick={() => menuClick()}
                alt="MapIt menu icon"/>
            </div>
        </div>
        { showMenu && 
            <div className="mmenu-tree">
                <div className="mmenu-button" onClick={() => menuClick()}>
                <p onClick={() => setCreate(false)} className="mdemo-text">
                    {!user || (user && Object.keys(user).length === 0)
                    ?
                    <Link className="Link-style" to="/" spy={true} smooth={true}>Home</Link>
                    :
                    <Link className="Link-style" to="/projectview" spy={true} smooth={true}>Projects</Link>
                    }
                </p>
                </div>
                <Link to="/industries" spy={true} smooth={true}>
                <div className="mmenu-button" onClick={() => menuClick()}> 
                    <p className="mdemo-text">
                    Use Cases
                    </p>
                </div>
                </Link>
                <Link to="/contact" spy={true} smooth={true}>
                <div className="mmenu-button" onClick={() => menuClick()}> 
                    <p className="mdemo-text">
                    Contact
                    </p>
                </div>
                </Link>
                <Link to="/pricing" spy={true} smooth={true}>
                <div className="mmenu-button" onClick={() => menuClick()}> 
                    <p className="mdemo-text">
                    Pricing
                    </p>
                </div>
                </Link>
                {/* <div className="mmenu-button-center" onClick={() => menuClick()}> 
                    <p className="mdemo-text">
                    <Link to="/create" spy={true} smooth={true}>
                        <MapItButton onSubmit={()=>{}} text="Create" className="mcreateBtn"></MapItButton>
                    </Link>                             
                    </p>
                </div> */}
                {!user || Object.keys(user).length === 0
                ?
                <div className="mlogin-signup-div">
                    <div className='mmenu-item-div'>
                        <p onClick={() => onLogin()} className="Menu-item">
                        <Link className="Link-style" to="/login" spy={true} smooth={true}>Log In</Link>
                        </p>
                    </div>
                    <div className='mmenu-item-div2'>
                        <p onClick={() => setCreate(false)} className="Menu-item">
                        <Link className="Link-style" to="/login" spy={true} smooth={true}>
                        <MapItButton onSubmit={() => onSignUp()} text="Sign Up" className="msignup-mapitBtn"></MapItButton>
                        </Link>
                        </p>
                    </div>
                </div>
                :
                <></>
                }
            </div>
        }
           {showAccList &&
      <div ref={menuRef} className="macc-tree">
        <div className="macc-tree-inner">
        <div className="acc-details">
          <div className="acc-name">
            <p className="name-item">
              {user.first_name} {user.last_name}
            </p>
            <p className="email-item">
              {user.email}
            </p>
          </div>
        </div>
        <hr className="hr-acc"></hr>
        <div className="acc-sub">
          <div className="acc-name">
            <p className="email-item">
              Subscription Plan: {sub_map[user.sub_plan]}
            </p>
            {user.sub_cancel_pending &&
            <div className="acc-name">
              <p className="email-item">Cancellation Date: {user.sub_cancel_pending} </p>
            </div>
            }
          </div>
        </div>
        <hr className="hr-acc"></hr>
        <div onClick={() => onLogout()} className="macc-function">
          <p className="logout-item">
            Log Out
          </p>
        </div>
      </div>
      </div>
    }   
    </div>
  );
}

export default MHeader;
